import gcd from './gcd';
import fractionBuilder from "./fractionBuilder";
export default class Fraction {
    constructor(num, den) {
        this.num = num;
        this.den = den;
    }
    simplify() {
        let k = gcd(this.num, this.den);
        this.num = this.num / k;
        this.den = this.den / k;
        if (this.den < 0) {
            this.num *= -1;
            this.den *= -1;
        }
    }
    add(f) {
        if (typeof f === "number") {
            f = new Fraction(f, 1);
        }
        let newNum = this.num * f.den + f.num * this.den, newDen = this.den * f.den;
        let sum = new Fraction(newNum, newDen);
        sum.simplify();
        return sum;
    }
    minus(f) {
        if (typeof f === "number") {
            f = new Fraction(-f, 1);
        }
        else {
            f.num = -f.num;
        }
        return this.add(f);
    }
    multiply(f) {
        if (typeof f === "number") {
            f = new Fraction(f, 1);
        }
        let newNum = this.num * f.num, newDen = this.den * f.den;
        let product = new Fraction(newNum, newDen);
        product.simplify();
        return product;
    }
    divide(f) {
        let f1;
        if (typeof f === "number") {
            f1 = new Fraction(1, f);
        }
        else {
            f1 = new Fraction(f.den, f.num);
        }
        return this.multiply(f1);
    }
    pow(n) {
        let f = new Fraction(Math.pow(this.num, n), Math.pow(this.den, n));
        f.simplify();
        return f;
    }
    toString() {
        this.simplify();
        if (this.den == 1 || this.num == 0) { // integer
            return this.num.toString();
        }
        else {
            let latexString = '';
            if (this.num < 0) {
                latexString = "-";
            }
            return latexString + fractionBuilder(Math.abs(this.num), this.den);
        }
    }
}
